// Site Coverage Action Types
export const FETCH_SITE_COVERAGE_DETAILS_REQUEST = 'FETCH_SITE_COVERAGE_DETAILS_REQUEST';
export const FETCH_SITE_COVERAGE_DETAILS_SUCCESS = 'FETCH_SITE_COVERAGE_DETAILS_SUCCESS';
export const FETCH_SITE_COVERAGE_DETAILS_FAILURE = 'FETCH_SITE_COVERAGE_DETAILS_FAILURE';

// Site Coverage Details By ID Action Types
export const FETCH_SITE_COVERAGE_DETAIL_BY_ID_REQUEST = 'FETCH_SITE_COVERAGE_DETAIL_BY_ID_REQUEST';
export const FETCH_SITE_COVERAGE_DETAIL_BY_ID_SUCCESS = 'FETCH_SITE_COVERAGE_DETAIL_BY_ID_SUCCESS';
export const FETCH_SITE_COVERAGE_DETAIL_BY_ID_FAILURE = 'FETCH_SITE_COVERAGE_DETAIL_BY_ID_FAILURE';

// Delete Site Coverage Detail Action Types
export const DELETE_SITE_COVERAGE_DETAIL_REQUEST = 'DELETE_SITE_COVERAGE_DETAIL_REQUEST';
export const DELETE_SITE_COVERAGE_DETAIL_SUCCESS = 'DELETE_SITE_COVERAGE_DETAIL_SUCCESS';
export const DELETE_SITE_COVERAGE_DETAIL_FAILURE = 'DELETE_SITE_COVERAGE_DETAIL_FAILURE';

// Save Site Coverage Detail Action Types
export const SAVE_SITE_COVERAGE_DETAIL_REQUEST = 'SAVE_SITE_COVERAGE_DETAIL_REQUEST';
export const SAVE_SITE_COVERAGE_DETAIL_SUCCESS = 'SAVE_SITE_COVERAGE_DETAIL_SUCCESS';
export const SAVE_SITE_COVERAGE_DETAIL_FAILURE = 'SAVE_SITE_COVERAGE_DETAIL_FAILURE';

//Get Coverage Gap action types
export const FETCH_COVERAGE_GAP_REQUEST = 'FETCH_COVERAGE_GAP_REQUEST';
export const FETCH_COVERAGE_GAP_SUCCESS = 'FETCH_COVERAGE_GAP_SUCCESS';
export const FETCH_COVERAGE_GAP_FAILURE = 'FETCH_COVERAGE_GAP_FAILURE';

//save coverage gap action types
export const SAVE_COVERAGE_GAP_REQUEST = 'SAVE_COVERAGE_GAP_REQUEST';
export const SAVE_COVERAGE_GAP_SUCCESS = 'SAVE_COVERAGE_GAP_SUCCESS';
export const SAVE_COVERAGE_GAP_FAILURE = 'SAVE_COVERAGE_GAP_FAILURE';

//Delete coverage gap action types
export const DELETE_COVERAGE_GAP_REQUEST = 'DELETE_COVERAGE_GAP_REQUEST';
export const DELETE_COVERAGE_GAP_SUCCESS = 'DELETE_COVERAGE_GAP_SUCCESS';
export const DELETE_COVERAGE_GAP_FAILURE = 'DELETE_COVERAGE_GAP_FAILURE';

//Get By ID coverage gap action types
export const FETCH_COVERAGE_GAP_BY_ID_REQUEST = 'FETCH_COVERAGE_GAP_BY_ID_REQUEST';
export const FETCH_COVERAGE_GAP_BY_ID_SUCCESS = 'FETCH_COVERAGE_GAP_BY_ID_SUCCESS';
export const FETCH_COVERAGE_GAP_BY_ID_FAILURE = 'FETCH_COVERAGE_GAP_BY_ID_FAILURE';

// Priority SLA Mapping Action Types
export const FETCH_PRIORITY_SLA_MAPPINGS_REQUEST = 'FETCH_PRIORITY_SLA_MAPPINGS_REQUEST';
export const FETCH_PRIORITY_SLA_MAPPINGS_SUCCESS = 'FETCH_PRIORITY_SLA_MAPPINGS_SUCCESS';
export const FETCH_PRIORITY_SLA_MAPPINGS_FAILURE = 'FETCH_PRIORITY_SLA_MAPPINGS_FAILURE';

export const FETCH_PRIORITY_SLA_MAPPING_BY_ID_REQUEST = 'FETCH_PRIORITY_SLA_MAPPING_BY_ID_REQUEST';
export const FETCH_PRIORITY_SLA_MAPPING_BY_ID_SUCCESS = 'FETCH_PRIORITY_SLA_MAPPING_BY_ID_SUCCESS';
export const FETCH_PRIORITY_SLA_MAPPING_BY_ID_FAILURE = 'FETCH_PRIORITY_SLA_MAPPING_BY_ID_FAILURE';

export const SAVE_PRIORITY_SLA_MAPPING_REQUEST = 'SAVE_PRIORITY_SLA_MAPPING_REQUEST';
export const SAVE_PRIORITY_SLA_MAPPING_SUCCESS = 'SAVE_PRIORITY_SLA_MAPPING_SUCCESS';
export const SAVE_PRIORITY_SLA_MAPPING_FAILURE = 'SAVE_PRIORITY_SLA_MAPPING_FAILURE';

export const DELETE_PRIORITY_SLA_MAPPING_REQUEST = 'DELETE_PRIORITY_SLA_MAPPING_REQUEST';
export const DELETE_PRIORITY_SLA_MAPPING_SUCCESS = 'DELETE_PRIORITY_SLA_MAPPING_SUCCESS';
export const DELETE_PRIORITY_SLA_MAPPING_FAILURE = 'DELETE_PRIORITY_SLA_MAPPING_FAILURE';

export const DROPDOWN_PRIORITY_REQUEST = 'DROPDOWN_PRIORITY_REQUEST';
export const DROPDOWN_PRIORITY_SUCCESS = 'DROPDOWN_PRIORITY_SUCCESS';
export const DROPDOWN_PRIORITY_FAILURE = 'DROPDOWN_PRIORITY_FAILURE';

export const ACTIVATE_DEACTIVATE_PRIORITY_SLA_MAPPING_REQUEST = 'ACTIVATE_DEACTIVATE_PRIORITY_SLA_MAPPING_REQUEST';
export const ACTIVATE_DEACTIVATE_PRIORITY_SLA_MAPPING_SUCCESS = 'ACTIVATE_DEACTIVATE_PRIORITY_SLA_MAPPING_SUCCESS';
export const ACTIVATE_DEACTIVATE_PRIORITY_SLA_MAPPING_FAILURE = 'ACTIVATE_DEACTIVATE_PRIORITY_SLA_MAPPING_FAILURE';

export const FETCH_PRIORITY_SLA_BUCKETS_REQUEST = 'FETCH_PRIORITY_SLA_BUCKETS_REQUEST';
export const FETCH_PRIORITY_SLA_BUCKETS_SUCCESS = 'FETCH_PRIORITY_SLA_BUCKETS_SUCCESS';
export const FETCH_PRIORITY_SLA_BUCKETS_FAILURE = 'FETCH_PRIORITY_SLA_BUCKETS_FAILURE';

// License Mapping Action Types
export const FETCH_STATE_LICENSE_MAPPING_REQUEST = 'FETCH_STATE_LICENSE_MAPPING_REQUEST';
export const FETCH_STATE_LICENSE_MAPPING_SUCCESS = 'FETCH_STATE_LICENSE_MAPPING_SUCCESS';
export const FETCH_STATE_LICENSE_MAPPING_FAILURE = 'FETCH_STATE_LICENSE_MAPPING_FAILURE';

export const FETCH_STATE_LICENSE_MAPPING_DROPDOWN_REQUEST = 'FETCH_STATE_LICENSE_MAPPING_DROPDOWN_REQUEST';
export const FETCH_STATE_LICENSE_MAPPING_DROPDOWN_SUCCESS = 'FETCH_STATE_LICENSE_MAPPING_DROPDOWN_SUCCESS';
export const FETCH_STATE_LICENSE_MAPPING_DROPDOWN_FAILURE = 'FETCH_STATE_LICENSE_MAPPING_DROPDOWN_FAILURE';

export const SAVE_STATE_LICENSE_MAPPING_BULK_REQUEST = 'SAVE_STATE_LICENSE_MAPPING_BULK_REQUEST';
export const SAVE_STATE_LICENSE_MAPPING_BULK_SUCCESS = 'SAVE_STATE_LICENSE_MAPPING_BULK_SUCCESS';
export const SAVE_STATE_LICENSE_MAPPING_BULK_FAILURE = 'SAVE_STATE_LICENSE_MAPPING_BULK_FAILURE';

// Privileges Mapping Action Types
export const FETCH_PRIVILEGES_MAPPING_REQUEST = 'FETCH_PRIVILEGES_MAPPING_REQUEST';
export const FETCH_PRIVILEGES_MAPPING_SUCCESS = 'FETCH_PRIVILEGES_MAPPING_SUCCESS';
export const FETCH_PRIVILEGES_MAPPING_FAILURE = 'FETCH_PRIVILEGES_MAPPING_FAILURE';

export const FETCH_PRIVILEGES_MAPPING_DROPDOWN_REQUEST = 'FETCH_PRIVILEGES_MAPPING_DROPDOWN_REQUEST';
export const FETCH_PRIVILEGES_MAPPING_DROPDOWN_SUCCESS = 'FETCH_PRIVILEGES_MAPPING_DROPDOWN_SUCCESS';
export const FETCH_PRIVILEGES_MAPPING_DROPDOWN_FAILURE = 'FETCH_PRIVILEGES_MAPPING_DROPDOWN_FAILURE';

export const SAVE_PRIVILEGES_MAPPING_BULK_REQUEST = 'SAVE_PRIVILEGES_MAPPING_BULK_REQUEST';
export const SAVE_PRIVILEGES_MAPPING_BULK_SUCCESS = 'SAVE_PRIVILEGES_MAPPING_BULK_SUCCESS';
export const SAVE_PRIVILEGES_MAPPING_BULK_FAILURE = 'SAVE_PRIVILEGES_MAPPING_BULK_FAILURE';

// Reading Status Mapping Action Types
export const FETCH_READING_STATUS_MAPPING_REQUEST = 'FETCH_READING_STATUS_MAPPING_REQUEST';
export const FETCH_READING_STATUS_MAPPING_SUCCESS = 'FETCH_READING_STATUS_MAPPING_SUCCESS';
export const FETCH_READING_STATUS_MAPPING_FAILURE = 'FETCH_READING_STATUS_MAPPING_FAILURE';

export const FETCH_READING_STATUS_MAPPING_DROPDOWN_REQUEST = 'FETCH_READING_STATUS_MAPPING_DROPDOWN_REQUEST';
export const FETCH_READING_STATUS_MAPPING_DROPDOWN_SUCCESS = 'FETCH_READING_STATUS_MAPPING_DROPDOWN_SUCCESS';
export const FETCH_READING_STATUS_MAPPING_DROPDOWN_FAILURE = 'FETCH_READING_STATUS_MAPPING_DROPDOWN_FAILURE';

export const SAVE_READING_STATUS_MAPPING_BULK_REQUEST = 'SAVE_READING_STATUS_MAPPING_BULK_REQUEST';
export const SAVE_READING_STATUS_MAPPING_BULK_SUCCESS = 'SAVE_READING_STATUS_MAPPING_BULK_SUCCESS';
export const SAVE_READING_STATUS_MAPPING_BULK_FAILURE = 'SAVE_READING_STATUS_MAPPING_BULK_FAILURE';
export const FETCH_DEFINE_MISMATCH_REQUEST = 'FETCH_DEFINE_MISMATCH_REQUEST';
export const FETCH_DEFINE_MISMATCH_SUCCESS = 'FETCH_DEFINE_MISMATCH_SUCCESS';
export const FETCH_DEFINE_MISMATCH_FAILURE = 'FETCH_DEFINE_MISMATCH_FAILURE';

export const FETCH_DEFINE_MISMATCH_DROPDOWN_REQUEST = 'FETCH_DEFINE_MISMATCH_DROPDOWN_REQUEST';
export const FETCH_DEFINE_MISMATCH_DROPDOWN_SUCCESS = 'FETCH_DEFINE_MISMATCH_DROPDOWN_SUCCESS';
export const FETCH_DEFINE_MISMATCH_DROPDOWN_FAILURE = 'FETCH_DEFINE_MISMATCH_DROPDOWN_FAILURE';

export const SAVE_DEFINE_MISMATCH_REQUEST = 'SAVE_DEFINE_MISMATCH_REQUEST';
export const SAVE_DEFINE_MISMATCH_SUCCESS = 'SAVE_DEFINE_MISMATCH_SUCCESS';
export const SAVE_DEFINE_MISMATCH_FAILURE = 'SAVE_DEFINE_MISMATCH_FAILURE';

export const ACTIVATE_DEACTIVATE_DEFINE_MISMATCH_REQUEST = 'ACTIVATE_DEACTIVATE_DEFINE_MISMATCH_REQUEST';
export const ACTIVATE_DEACTIVATE_DEFINE_MISMATCH_SUCCESS = 'ACTIVATE_DEACTIVATE_DEFINE_MISMATCH_SUCCESS';
export const ACTIVATE_DEACTIVATE_DEFINE_MISMATCH_FAILURE = 'ACTIVATE_DEACTIVATE_DEFINE_MISMATCH_FAILURE';

export const DELETE_DEFINE_MISMATCH_REQUEST = 'DELETE_DEFINE_MISMATCH_REQUEST';
export const DELETE_DEFINE_MISMATCH_SUCCESS = 'DELETE_DEFINE_MISMATCH_SUCCESS';
export const DELETE_DEFINE_MISMATCH_FAILURE = 'DELETE_DEFINE_MISMATCH_FAILURE';


// Shift Hour Configuration Action Types
export const FETCH_SHIFT_HOUR_REQUEST = 'FETCH_SHIFT_HOUR_REQUEST';
export const FETCH_SHIFT_HOUR_SUCCESS = 'FETCH_SHIFT_HOUR_SUCCESS';
export const FETCH_SHIFT_HOUR_FAILURE = 'FETCH_SHIFT_HOUR_FAILURE';

//--------------------- DLS Configuration Action Types - Start---------------------//
// DLS Configuration Action Types
export const FETCH_DLS_CONFIGURATION_REQUEST = 'FETCH_DLS_CONFIGURATION_REQUEST';
export const FETCH_DLS_CONFIGURATION_SUCCESS = 'FETCH_DLS_CONFIGURATION_SUCCESS';
export const FETCH_DLS_CONFIGURATION_FAILURE = 'FETCH_DLS_CONFIGURATION_FAILURE';

// Sites Without DLS Action Types
export const FETCH_SITES_WITHOUT_DLS_REQUEST = 'FETCH_SITES_WITHOUT_DLS_REQUEST';
export const FETCH_SITES_WITHOUT_DLS_SUCCESS = 'FETCH_SITES_WITHOUT_DLS_SUCCESS';
export const FETCH_SITES_WITHOUT_DLS_FAILURE = 'FETCH_SITES_WITHOUT_DLS_FAILURE';

// Save DLS Configuration Action Types
export const SAVE_DLS_CONFIGURATION_REQUEST = 'SAVE_DLS_CONFIGURATION_REQUEST';
export const SAVE_DLS_CONFIGURATION_SUCCESS = 'SAVE_DLS_CONFIGURATION_SUCCESS';
export const SAVE_DLS_CONFIGURATION_FAILURE = 'SAVE_DLS_CONFIGURATION_FAILURE';
//--------------------- DLS Configuration Action Types - End---------------------//

//Block Planning 
export const FETCH_BLOCK_PLANNING_REQUEST = 'FETCH_BLOCK_PLANNING_REQUEST';
export const FETCH_BLOCK_PLANNING_SUCCESS = 'FETCH_BLOCK_PLANNING_SUCCESS';
export const FETCH_BLOCK_PLANNING_FAILURE = 'FETCH_BLOCK_PLANNING_FAILURE';

//Block Planning Action Types Details By ID 
export const FETCH_BLOCK_PLANNING_BY_ID_REQUEST = 'FETCH_BLOCK_PLANNING_BY_ID_REQUEST';
export const FETCH_BLOCK_PLANNING_BY_ID_SUCCESS = 'FETCH_BLOCK_PLANNING_BY_ID_SUCCESS';
export const FETCH_BLOCK_PLANNING_BY_ID_FAILURE = 'FETCH_BLOCK_PLANNING_BY_ID_FAILURE';

// Delete Block Planning Detail 
export const DELETE_BLOCK_PLANNING_REQUEST = 'DELETE_BLOCK_PLANNING_REQUEST';
export const DELETE_BLOCK_PLANNING_SUCCESS = 'DELETE_BLOCK_PLANNING_SUCCESS';
export const DELETE_BLOCK_PLANNING_FAILURE = 'DELETE_BLOCK_PLANNING_FAILURE';

//save Block Planning Detail
export const SAVE_BLOCK_PLANNING_REQUEST = 'SAVE_BLOCK_PLANNING_REQUEST';
export const SAVE_BLOCK_PLANNING_SUCCESS = 'SAVE_BLOCK_PLANNING_SUCCESS';
export const SAVE_BLOCK_PLANNING_FAILURE = 'SAVE_BLOCK_PLANNING_FAILURE';


//--------------------- Day of Week Configuration Action Types - Start---------------------//
// Day of Week Configuration Action Types
export const FETCH_DAY_OF_WEEK_CONFIGURATION_REQUEST = 'FETCH_DAY_OF_WEEK_CONFIGURATION_REQUEST';
export const FETCH_DAY_OF_WEEK_CONFIGURATION_SUCCESS = 'FETCH_DAY_OF_WEEK_CONFIGURATION_SUCCESS';
export const FETCH_DAY_OF_WEEK_CONFIGURATION_FAILURE = 'FETCH_DAY_OF_WEEK_CONFIGURATION_FAILURE';
//--------------------- Day of Week Configuration Action Types - End---------------------//


// Common Action Types
// Task Configuration Action Types
export const FETCH_TASK_CONFIGURATION_DETAILS_REQUEST = 'FETCH_TASK_CONFIGURATION_DETAILS_REQUEST';
export const FETCH_TASK_CONFIGURATION_DETAILS_SUCCESS = 'FETCH_TASK_CONFIGURATION_DETAILS_SUCCESS';
export const FETCH_TASK_CONFIGURATION_DETAILS_FAILURE = 'FETCH_TASK_CONFIGURATION_DETAILS_FAILURE';

//save Task configuration details
export const SAVE_TASK_CONFIGURATION_REQUEST = 'SAVE_TASK_CONFIGURATION_REQUEST';
export const SAVE_TASK_CONFIGURATION_SUCCESS = 'SAVE_TASK_CONFIGURATION_SUCCESS';
export const SAVE_TASK_CONFIGURATION_FAILURE = 'SAVE_TASK_CONFIGURATION_FAILURE';

// Delete Task Configuration Detail 
export const DELETE_TASK_CONFIGURATION_REQUEST = 'DELETE_TASK_CONFIGURATION_REQUEST';
export const DELETE_TASK_CONFIGURATION_SUCCESS = 'DELETE_TASK_CONFIGURATION_SUCCESS';
export const DELETE_TASK_CONFIGURATION_FAILURE = 'DELETE_TASK_CONFIGURATION_FAILURE';


//Task Configuration By ID 
export const FETCH_TASK_CONFIGURATION_BY_ID_REQUEST = 'FETCH_TASK_CONFIGURATION_BY_ID_REQUEST';
export const FETCH_TASK_CONFIGURATION_BY_ID_SUCCESS = 'FETCH_TASK_CONFIGURATION_BY_ID_SUCCESS';
export const FETCH_TASK_CONFIGURATION_BY_ID_FAILURE = 'FETCH_TASK_CONFIGURATION_BY_ID_FAILURE';

//Activate Deactivate Task Configuration Action Types
export const ACTIVATE_DEACTIVATE_TASK_CONFIGURATION_REQUEST = 'ACTIVATE_DEACTIVATE_TASK_CONFIGURATION_REQUEST';
export const ACTIVATE_DEACTIVATE_TASK_CONFIGURATION_SUCCESS = 'ACTIVATE_DEACTIVATE_TASK_CONFIGURATION_SUCCESS';
export const ACTIVATE_DEACTIVATE_TASK_CONFIGURATION_FAILURE = 'ACTIVATE_DEACTIVATE_TASK_CONFIGURATION_FAILURE';

export const TASK_BULK_UPDATE_REQUEST = 'TASK_BULK_UPDATE_REQUEST';
export const TASK_BULK_UPDATE_SUCCESS = 'TASK_BULK_UPDATE_SUCCESS';
export const TASK_BULK_UPDATE_FAILURE = 'TASK_BULK_UPDATE_FAILURE';

export const FETCH_TASK_TAGS_REQUEST = 'FETCH_TASK_TAGS_REQUEST';
export const FETCH_TASK_TAGS_SUCCESS = 'FETCH_TASK_TAGS_SUCCESS';
export const FETCH_TASK_TAGS_FAILURE = 'FETCH_TASK_TAGS_FAILURE';

export const SAVE_TASK_TAGS_REQUEST = 'SAVE_TASK_TAGS_REQUEST';
export const SAVE_TASK_TAGS_SUCCESS = 'SAVE_TASK_TAGS_SUCCESS';
export const SAVE_TASK_TAGS_FAILURE = 'SAVE_TASK_TAGS_FAILURE';

// Provider Task Pool Action Types
export const FETCH_PROVIDER_TASK_POOL_REQUEST = 'FETCH_PROVIDER_TASK_POOL_REQUEST';
export const FETCH_PROVIDER_TASK_POOL_SUCCESS = 'FETCH_PROVIDER_TASK_POOL_SUCCESS';
export const FETCH_PROVIDER_TASK_POOL_FAILURE = 'FETCH_PROVIDER_TASK_POOL_FAILURE';

export const SAVE_PROVIDER_TASK_POOL_REQUEST = 'SAVE_PROVIDER_TASK_POOL_REQUEST';
export const SAVE_PROVIDER_TASK_POOL_SUCCESS = 'SAVE_PROVIDER_TASK_POOL_SUCCESS';
export const SAVE_PROVIDER_TASK_POOL_FAILURE = 'SAVE_PROVIDER_TASK_POOL_FAILURE';

export const FETCH_PROVIDER_TASK_POOL_PROVIDER_OPTIONS_REQUEST = 'FETCH_PROVIDER_TASK_POOL_PROVIDER_OPTIONS_REQUEST';
export const FETCH_PROVIDER_TASK_POOL_PROVIDER_OPTIONS_SUCCESS = 'FETCH_PROVIDER_TASK_POOL_PROVIDER_OPTIONS_SUCCESS';
export const FETCH_PROVIDER_TASK_POOL_PROVIDER_OPTIONS_FAILURE = 'FETCH_PROVIDER_TASK_POOL_PROVIDER_OPTIONS_FAILURE';

export const ADD_PROVIDER_TASK_POOL_PROVIDERS_REQUEST = 'ADD_PROVIDER_TASK_POOL_PROVIDERS_REQUEST';
export const ADD_PROVIDER_TASK_POOL_PROVIDERS_SUCCESS = 'ADD_PROVIDER_TASK_POOL_PROVIDERS_SUCCESS';
export const ADD_PROVIDER_TASK_POOL_PROVIDERS_FAILURE = 'ADD_PROVIDER_TASK_POOL_PROVIDERS_FAILURE';

export const REMOVE_PROVIDER_TASK_POOL_PROVIDER_REQUEST = 'REMOVE_PROVIDER_TASK_POOL_PROVIDER_REQUEST';
export const REMOVE_PROVIDER_TASK_POOL_PROVIDER_SUCCESS = 'REMOVE_PROVIDER_TASK_POOL_PROVIDER_SUCCESS';
export const REMOVE_PROVIDER_TASK_POOL_PROVIDER_FAILURE = 'REMOVE_PROVIDER_TASK_POOL_PROVIDER_FAILURE';

export const EXPORT_PROVIDER_TASK_POOL_REQUEST = 'EXPORT_PROVIDER_TASK_POOL_REQUEST';
export const EXPORT_PROVIDER_TASK_POOL_SUCCESS = 'EXPORT_PROVIDER_TASK_POOL_SUCCESS';
export const EXPORT_PROVIDER_TASK_POOL_FAILURE = 'EXPORT_PROVIDER_TASK_POOL_FAILURE';

//Simulation Action Types
export const FETCH_SIMULATION_REQUEST = 'FETCH_SIMULATION_REQUEST';
export const FETCH_SIMULATION_SUCCESS = 'FETCH_SIMULATION_SUCCESS';
export const FETCH_SIMULATION_FAILURE = 'FETCH_SIMULATION_FAILURE';

export const SAVE_SIMULATION_REQUEST = 'SAVE_SIMULATION_REQUEST';
export const SAVE_SIMULATION_SUCCESS = 'SAVE_SIMULATION_SUCCESS';
export const SAVE_SIMULATION_FAILURE = 'SAVE_SIMULATION_FAILURE';

export const DELETE_SIMULATION_REQUEST = 'DELETE_SIMULATION_REQUEST';
export const DELETE_SIMULATION_SUCCESS = 'DELETE_SIMULATION_SUCCESS';
export const DELETE_SIMULATION_FAILURE = 'DELETE_SIMULATION_FAILURE';

export const FETCH_SIMULATION_BY_ID_REQUEST = 'FETCH_SIMULATION_BY_ID_REQUEST';
export const FETCH_SIMULATION_BY_ID_SUCCESS = 'FETCH_SIMULATION_BY_ID_SUCCESS'; 
export const FETCH_SIMULATION_BY_ID_FAILURE = 'FETCH_SIMULATION_BY_ID_FAILURE';
//Simulation Action Types End

export const UPDATE_CONFIGURATION_REDUCER = 'UPDATE_CONFIGURATION_REDUCER';